import { render, staticRenderFns } from "./RedText.vue?vue&type=template&id=1c7ff749&"
import script from "./RedText.vue?vue&type=script&lang=js&"
export * from "./RedText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports